import { Injectable, ErrorHandler, inject } from '@angular/core';
import { SentinelService } from '@bannerflow/sentinel';

@Injectable({
  providedIn: 'root',
})
export class AppErrorHandler implements ErrorHandler {
  private readonly sentinelService = inject(SentinelService);

  handleError(error: any): void {
    this.sentinelService.error(error, { context: 'AppErrorHandler' });
  }
}
